const React = require('react');
const createReactClass = require('create-react-class');

const Helpers = require('../helpers.js');
const Convert = require('ansi-to-html');

const convert = new Convert();

const Log = createReactClass({

	getInitialState: function() {
		return {
			options: {
				'word-wrap': 'Word wrap'
			},
			logClass: {
				'log-content': true,
				'fade-in': true,
				'show-line-numbers': true,
				'word-wrap': this.getSetting('word-wrap')
			}
		};
	},

	componentDidMount: function() {
		// for the first render
		this.scrollToBottom();
	},

	componentDidUpdate: function() {
		if (this.autoScroll) {
			this.scrollToBottom();
			// we have to re-enable autoscroll because we have programmatically triggered a scroll event
			this.autoScroll = true;
		}
	},

	componentWillUnmount: function() {
		this.teardownOnScroll();
	},

	setupOnScroll: function() {
		$(this.el).on('scroll', function() {
			// if we are scrolled to the bottom then autoScroll should be on otherwise we've scrolled somewhere else
			// and we shouldn't move the scroll any more
			if ($(this.el).scrollTop() >= ($(this.el)[0].scrollHeight - $(this.el).innerHeight())) {
				this.autoScroll = true;
			} else {
				this.autoScroll = false;
			}
		}.bind(this));
	},

	getSetting: function(key) {
		return JSON.parse(window.localStorage.getItem(key)) === true;
	},

	toggleSetting: function(e) {
		window.localStorage.setItem(e.target.id, JSON.stringify(e.target.checked));

		const logClasses = this.state.logClass;
		logClasses[e.target.id] = e.target.checked;

		this.setState({
			logClass: logClasses
		});
	},

	scrollToBottom: function() {
		if ($(this.el).length > 0) {
			$(this.el).scrollTop($(this.el)[0].scrollHeight);
		}
	},

	teardownOnScroll: function() {
		$(this.el).off('scroll');
	},

	contentMounted: function(el) {
		this.el = el;
		this.setupOnScroll();
	},

	el: null,

	autoScroll: true,

	render: function() {
		if (this.props.content.length === 0) {
			return <div className="alert alert-warning">No log events could be found</div>;
		}

		const lines = Object.keys(this.props.content).map(function(key) {
			return (
					<div key={key}>
						<a id={'L' + key}>
							<span className="sr-only">Link to line</span>
						</a>
						<span dangerouslySetInnerHTML={{__html: convert.toHtml(this.props.content[key])}} />
					</div>
			);
		}.bind(this));

		const options = Object.keys(this.state.options).map(function(key) {
			const checked = this.getSetting(key);

			return (
				<label key={key} htmlFor={key}>
					<input type="checkbox" id={key} onClick={this.toggleSetting} defaultChecked={checked} />
					{this.state.options[key]}
				</label>
			);
		}.bind(this));

		return (
			<div className="log-container">
				<div className="log-header">
					Deployment log
					<div className="log-actions">
						{options}
					</div>
				</div>
				<pre
					className={Helpers.classNames(this.state.logClass)}
					ref={this.contentMounted}
				>
					{lines}
				</pre>
			</div>
		);
	}
});

module.exports = Log;
